export default {
  headerContent: {
    title: 'Quick Sigorta Zorunlu Trafik Sigortası Teklif Al',
    slogan: "Trafik Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TRAFİK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Quick Sigorta Zorunlu Trafik Sigortası',
    description: {
      title: 'Quick Sigorta Zorunlu Trafik Sigortası Nedir? ',
      content: [
        'Quick Sigorta zorunlu trafik sigortası motorlu taşıtın karayolunda kaza yapması sonucunda üçüncü şahısların uğrayacağı zararlardan doğan hukuki sorumlulukları güvence altına almaktadır.'
      ]
    },
    subContent: {
      title: 'Quick Sigorta Zorunlu Trafik Sigortası Ana Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Trafik sigortası ana teminatları Hazine Müsteşarlığı tarafından yıllık olarak belirlenmektedir.',
          subList: null
        },
        {
          paragraph: 'Bu kapsamda trafik sigortası ana teminatları;',
          subList: [
            'Maddi zararlar.',
            'Sakatlanma ve ölüm.',
            'Sağlık giderleri olmak üzere 3’e ayrılmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Trafik Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Trafik Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Trafik Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Quick Sigorta Trafik Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
